/**
 * SocialPanel — the reachable home for the social graph + activity (Phases B & D).
 *
 * Composes the previously-unmounted components: inbound requests, the
 * connections list, and the activity feed. Each child self-gates on its own
 * flag, so the panel degrades cleanly when a phase is off. Reached via the
 * "Connections" nav item (shown only when `social.graph` is on).
 *
 * `onMessage` is intentionally omitted: connection DMs ride the v2 message
 * spine, whose backend does not exist yet (G2), so the "Message" affordance is
 * inert until that lands.
 */

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { ConnectionRequests } from './ConnectionRequests';
import { ConnectionsList } from './ConnectionsList';
import { ActivityFeed } from './ActivityFeed';
import { BlockedList } from './BlockedList';
import './SocialPanel.css';

export function SocialPanel() {
  const graphEnabled = useFeatureFlag('social.graph');
  const feedEnabled = useFeatureFlag('social.invites_feed');

  return (
    <div className="social-panel">
      <h1 className="social-panel__title">Connections</h1>

      {graphEnabled && (
        <>
          <section className="social-panel__section">
            <h2>Requests</h2>
            <ConnectionRequests />
          </section>

          <section className="social-panel__section">
            <h2>Your connections</h2>
            <ConnectionsList />
          </section>

          <section className="social-panel__section">
            <h2>Blocked</h2>
            <BlockedList />
          </section>
        </>
      )}

      {feedEnabled && (
        <section className="social-panel__section">
          <h2>Activity</h2>
          <ActivityFeed />
        </section>
      )}

      {!graphEnabled && !feedEnabled && (
        <p className="social-panel__empty">
          Connections aren&apos;t enabled yet.
        </p>
      )}
    </div>
  );
}

export default SocialPanel;
